












import Vue from "vue";
import { ZastosowanieCategory } from "@megarax/client/src/resources/plm";
import AttributeTable from "./AttributeTable.vue";

export default Vue.extend({
  components: { AttributeTable },
  props: {
    value: {
      type: ZastosowanieCategory,
      required: true,
    },
  },
});
